<ng-container
  *ngIf="{
    companies: companies$ | async,
    monthlyOverviewData: monthlyOverviewData$ | async,
    selectedCompany: selectedCompany$ | async,
    quarterlyBalance: quarterlyBalance$ | async
  } as data"
>
  <div class="menu" #menu [ngClass]="{ open: isMenuOpen }">
    <!-- *ngIf="!isLoadingMixed" -->
    <div class="selected-company" (click)="toggleMenu()">
      <img
        [@rotate]="isMenuOpen ? 'rotated' : 'default'"
        src="../../assets/arrow-down-dark-blue.svg"
        alt="Arrow"
      />
      <span>{{ selectedCompanyName }}</span>
    </div>
    <div class="companies" [@openClose]="isMenuOpen ? 'open' : 'closed'">
      <div
        *ngFor="let company of data.companies"
        [ngClass]="{ selected: company._id === data.selectedCompany?._id }"
        class="company"
        (click)="selectCompany(company)"
      >
        <div class="image-container">
          <img
            *ngIf="company._id === data.selectedCompany?._id"
            src="../../assets/checkmark-round-white-in-light-green.svg"
            alt="Checkmark"
          />
        </div>
        {{ company.name }}
      </div>
    </div>
  </div>

  <div class="dashboard-wrapper-container-skeleton" *ngIf="isLoadingMixed">
    <div class="actions-container-skeleton">
      <div class="actions-container-skeleton-item"></div>
      <div class="counter-container-skeleton-item"></div>
      <div class="counter-container-skeleton-item"></div>
    </div>
    <div class="projects-container-skeleton"></div>
    <div class="overview-container-skeleton">
      <div class="balance-container-skeleton-item"></div>
      <div class="counter-container-skeleton-item"></div> 
      <div class="monthly-container-skeleton-item"></div>
    </div>
  </div>
  <div
    class="dashboard-wrapper missing-sub"
    id="dashboard-container"
    [class.opacity]="isLoadingMixed"
    [class.loaded]="!isLoadingMixed && show_restriction"
    *ngIf="!isLoadingMixed && show_restriction"
  >
    <div class="missing-subscription-message">
      {{ 'auth.dashboard.subscriptionNotActive' | translate }}
    </div>
  </div>
  <div
    class="dashboard-wrapper"
    [class.opacity]="isLoadingMixed"
    [class.loaded]="!isLoadingMixed && !show_restriction"
    id="dashboard-container-1"
    *ngIf="!isLoadingMixed && !show_restriction"
  >
    <div class="cashflow-actions-empty" *ngIf="!show_M4"></div>

    <div
      class="cashflow-actions-container"
      *ngIf="!isLoadingMixed && !show_restriction && show_M4"
    >

      <app-actions (actionClicked)="onActionClicked($event)"></app-actions>
      <!-- DASHBOARD STATS (FOR LIMITATIONS) -->
      <ops-active-projects-stats
        [selectedCompanyId]="selectedCompanyIdStats"
      ></ops-active-projects-stats>
      <ops-completed-projects-stats
        [selectedCompanyId]="selectedCompanyIdStats"
      ></ops-completed-projects-stats>
    </div>
    <div class="add-cost-button" (click)="onAddCompanyCost()">
 
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            id="Vector"
            d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            [attr.stroke]="actionisHovered === 0 ? '#ffb800' : '#ffffff'"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
      <div class="action-title">{{ 'auth.dashboard.actions.addCompanyCost' | translate }}</div>
 
    </div>
    <app-projects
      *ngIf="!isLoadingMixed && !show_restriction"
      class="project-widget"
      (loadEstimate)="onLoadEstimate($event)"
      (loadCost)="onLoadCost($event)"
      (listMode)="onListMode($event)"
    ></app-projects>

    <app-monthly-overview
    [companyId]="data.selectedCompany?._id"
    ></app-monthly-overview>

    
    <!-- <app-quarterly-balance
      *ngIf="show_M4"
      [quarterlyBalance]="data.quarterlyBalance"
    ></app-quarterly-balance> -->

    <app-company-cost-add
      *ngIf="show_M4 && !show_restriction && data?.selectedCompany?._id"
      [companyId]="data?.selectedCompany?._id"
      id="add-cost-dashboard"
      (createCompanyCost)="onAddItem($event)"
      (createRecurringCost)="onAddRecurringCost($event)"
      (cancel)="onCancelAddItem()"
    ></app-company-cost-add>
  </div>
</ng-container>
